
import './CompteClient.scss';

import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {Outlet, useLocation, useNavigate } from 'react-router-dom';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import useWindowSize from '../../../hooks/useWindowSize';
//import {useWindowSize} from '../../../hooks/useWindowSize';
import { SideBarNavigationFicheExpert } from '../../../Styles/componentStyles';
//import { SelectComponent } from '../shared/ReusableSmallComponents';

function SideBar() {
    const {pathname} = useLocation();
    const currentPath = pathname.split('/').pop();
    const {device}=useWindowSize();
    const navigate = useNavigate();
    const [urlPage,setUrlPage]=useState('');
    const { i18n } = useTranslation();

    useEffect(() => {
        if(pathname){
            setUrlPage(pathname);
        }
    },[pathname]);

    const handleChangeUrl = async (e) => {
        const newUrl = e.target.value;
        await setUrlPage(newUrl);
        navigate(newUrl, { replace: true });
    };

    return (
        <>
            {device=='desktop' &&
                <div className='frame0SideBarClient'>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            (currentPath == 'CompteClient'||currentPath == 'DonneeFacturation'||currentPath == 'PrestationComplementaire') ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                (currentPath == 'CompteClient'||currentPath == 'DonneeFacturation'||currentPath == 'PrestationComplementaire') ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                if(currentPath == 'CompteClient')
                                    navigate('.');
                                else
                                    navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClient', { replace: true });
                            }}

                        >{i18n.t('Profil entreprise')}</p>

                    </div>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            (currentPath == 'CompteClientDocAdministratifs' || currentPath == 'CompteClientDocAdministratifsContrat' || currentPath=='PieceIdentite' || currentPath=='Kbis' || currentPath=='AttestationUrsaf' || currentPath=='Assurance' || currentPath=='AttestationFiscale' || currentPath=='Contrat'|| currentPath=='AttestationHonneur' ) ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >
                        <p
                            style={
                                (currentPath == 'CompteClientDocAdministratifs' || currentPath == 'CompteClientDocAdministratifsContrat' || currentPath=='PieceIdentite' || currentPath=='Kbis' || currentPath=='AttestationUrsaf' || currentPath=='Assurance' || currentPath=='AttestationFiscale' || currentPath=='Contrat'|| currentPath=='AttestationHonneur' ) ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                if(pathname.includes('gestionEsn'))
                                    navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PieceIdentite', { replace: true });
                                else
                                    navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientDocAdministratifs', { replace: true });
                            }}
                        >{i18n.t('Documents administratifs')}</p>
                    </div>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            currentPath == 'CompteClientDocCommerciaux' ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >

                        <p
                            style={
                                currentPath == 'CompteClientDocCommerciaux' ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientDocCommerciaux', { replace: true });
                            }}
                        >{i18n.t('Documents commerciaux')}</p>
                    </div>
                    <div
                        className='DocumentscommerciauxT'
                        style={
                            currentPath == 'CompteClientCollaborateurs' ?
                                SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                        }
                    >

                        <p
                            style={
                                currentPath == 'CompteClientCollaborateurs' ?
                                    SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                            }
                            onClick={()=>{
                                navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientCollaborateurs', { replace: true });
                            }}
                        >{i18n.t('Collaborateurs d\'entreprise')}</p>
                    </div>
                    {/* {pathname.includes('gestionEsn') &&
                            <div
                                className='frame5CompteClient'
                                style={
                                    currentPath == 'ClientsPartenaires' ? SideBarNavigationFicheExpert.selectedTitle : SideBarNavigationFicheExpert.notSelectedTitle
                                }
                            >
                                <p
                                    style={
                                        currentPath == 'ClientsPartenaires' ?
                                            SideBarNavigationFicheExpert.selectedTitleP : SideBarNavigationFicheExpert.notSelectedTitleP
                                    }
                                    onClick={()=>{
                                        navigate('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/ClientsPartenaires', { replace: true });
                                    }}
                                >{i18n.t('Clients partenaires')}</p>
                            </div>
                    } */}
                    <div>
                        <Outlet />
                    </div>
                </div>
            }
            {device!='desktop' &&
                <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
                    <div style={{width:'100%',minWidth:'200px',maxWidth:'500px'}}>
                        <SelectComponent
                            val={urlPage}
                            setVal={(e) => handleChangeUrl(e)}
                            listVal={[
                                {
                                    value:('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClient'),
                                    label:'Profil entreprise',
                                },
                                {
                                    value:('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClient'),
                                    label:'Profil entreprise',
                                    hidden:true,
                                },
                                {
                                    value:('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/DonneeFacturation'),
                                    label:'Profil entreprise',
                                    hidden:true,
                                },
                                {
                                    value:('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/PrestationComplementaire'),
                                    label:'Profil entreprise',
                                    hidden:true,
                                },
                                {
                                    value:
                                    '/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientDocAdministratifs',
                                    label:'Documents administratifs',
                                },
                                {
                                    value:
                                    ('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientDocCommerciaux'),
                                    label:'Documents commerciaux',
                                },
                                {
                                    value:
                                    ('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/CompteClientCollaborateurs'),
                                    label:'Collaborateurs d\'entreprise',
                                    // hidden:true,
                                },

                                {
                                    value:
                                    ('/'+((pathname.split('/')).slice(1,-1)).join('/')+'/ClientsPartenaires'),
                                    label:'Clients partenaires',
                                    // hidden:true,
                                },
                            ]}
                        />
                    </div>
                    <div>
                        <Outlet />
                    </div>
                </div>
            }
        </>

    );
}

export default SideBar;